import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route,
} from 'react-router-dom';
import Header from '../Header';
import Contents from '../Contents';
import StudioA from '../StudioA';
import PlanALive from '../PlanALive';
import Footer from '../Footer';

export default function Main() {
  return (
    <div>
      <BrowserRouter>
        <header style={{ paddingTop: '36px' }}>
          <Header />
        </header>
        <main>
          <Switch>
            <Route exact path="/studioA">
              <StudioA />
            </Route>
            <Route exact path="/planALive">
              <PlanALive />
            </Route>
            <Route path="/">
              <Contents />
            </Route>
          </Switch>
        </main>
      </BrowserRouter>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}
